import { ToggleProps } from '../interface/interface';

const Toggle = ({ label, value, onToggle, readonly }: ToggleProps) => {
  return (
    <label className="inline-flex items-center cursor-pointer">
      <span className="text-sm font-semibold text-secondary-pink-700 mr-3">
        {label}
      </span>
      <input
        type="checkbox"
        value=""
        className="sr-only peer"
        checked={value}
        onChange={(e) => onToggle(e.target.checked)}
        disabled={readonly}
      />
      <div
        className={`relative w-11 h-6 peer-focus:outline-none rounded-full peer bg-grey-400 
      peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full 
      peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] 
      after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full 
      after:h-5 after:w-5 after:transition-all peer-checked:bg-primary-blue-500 ${readonly && 'opacity-75 cursor-not-allowed'}`}
      ></div>
    </label>
  );
};

export default Toggle;
